import React from "react";
import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";

import { withState } from "../../../services/state";

import SlateLogo from "./Logo.png";

// Styled components using MUI v5 `styled` and proper breakpoint syntax
const PageHeaderRoot = styled("div")(({ theme }) => ({
  width: "100%",
  height: 60,
  backgroundColor: "#fff",
  borderBottom: "5px solid #47d45a",
  padding: 10,
  [theme.breakpoints.down("sm")]: {
    height: 50,
    display: "flex",
    alignItems: "center",
  },
}));

const PageHeaderLogo = styled("img")(({ theme }) => ({
  height: "100%",
  [theme.breakpoints.down("sm")]: {
    marginRight: 10,
  },
}));

const PageHeaderTitle = styled("div")({
  color: "#000",
  fontWeight: "bold",
  fontSize: 14,
  marginTop: 3,
});

const MenuToggle = styled("div")({
  cursor: "pointer",
  marginRight: 10,
  color: "#000",
});

const PageHeaderContent = styled("div")(({ theme }) => ({
  textAlign: "center",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    alignItems: "center",
  },
}));

function PageHeader({ setShowMinimizedSidebar, context }) {
  let logo = SlateLogo;
  if (context.organizationData) {
    logo = context.organizationData.logoSmallImageUrl;
  }

  let appHeader = "Player App";

  if (context.currentClub.isTreasurer) {
    appHeader = "Player App (Admin View)";
  } else if (context.currentClub.isCaptain) {
    appHeader = "Captain Portal";
  }

  return (
    <PageHeaderRoot>
      {window.innerWidth < 960 && (
        <MenuToggle onClick={() => setShowMinimizedSidebar()}>
          <MenuIcon />
        </MenuToggle>
      )}
      <PageHeaderContent>
        <PageHeaderLogo alt="Slate logo" src={logo} />
        <PageHeaderTitle>{appHeader}</PageHeaderTitle>
      </PageHeaderContent>
    </PageHeaderRoot>
  );
}

export default withState(PageHeader);
